import * as React from "react";
import { APINames } from "../../legacy/api/api.names";
import { IButtonEvents } from "../_common/buttonEvents";
import { SettingButton as Wrapper } from "../SettingButton";

export interface IAutoplaySettingButton extends IButtonEvents {
  enabled?: boolean;
  label?: string;
  requiredText?: string;
  active?: boolean;
  theme?: any;
}

export const AutoplaySettingButton = ({ ...props }: IAutoplaySettingButton) => (
  <Wrapper apiName={APINames.AUTOPLAY_SETTING_BUTTON} {...props} />
);
